export function useSportPage() {
  const route = useRoute()
  const sportId = computed(() => Number(route?.params?.sportId))
  const categoryId = computed(() => Number(route?.params?.categoryId))
  const tournamentId = computed(() => Number(route?.params?.tournamentId))
  const events = useSportEventsBySportId(sportId)

  const MS = useMarketsStore()
  const isCustomSport = computed(
    () => route?.params?.sportId.includes('custom'),
  )
  const eventsForTree = computed(() =>
    isCustomSport.value ? MS.sportEvents : events.value,
  )
  const sportIdForTree = computed(() =>
    isCustomSport.value ? String(route?.params?.sportId) : sportId.value,
  )

  const { singleSportTree } = useInitSportTree(eventsForTree, {
    sportId: sportIdForTree,
    categoryId,
    tournamentId,
  })

  return {
    singleSportTree,
    sportIdForTree,
  }
}
